import React from 'react';
import PropTypes from 'prop-types';
import { getBuyerId, getUserType } from 'dibs-cookie-jar';
import { connect } from 'react-redux';
import { setGuestId } from '../actions/sharedUserStorageActions';
import { updateRelayVariables } from '../actions/sharedRelayVariableActions';
import { CUSTOMER_TYPE_TRADE } from '../constants/userConstants';

export class SharedUserAndRelayVarLoaderComponent extends React.Component {
    constructor() {
        super();

        this.userFetched = false;
    }

    componentDidMount() {
        /**
         * Fetch the user if needed and refetch any fields that depend on `isClient`
         */
        this.triggerRefetch();
    }

    componentWillReceiveProps(nextProps) {
        /**
         * For cases where the user logs in while browsing the page.
         */
        if (!this.props.fetchUser && nextProps.fetchUser && !this.userFetched) {
            this.triggerRefetch();
        }
    }

    triggerRefetch() {
        const variables = {
            ...this.getUserRelayVars(),
            isClient: true,
        };
        /**
         * If there's no cookie set - means we're not gonna be fetching the user anytime soon and
         * it's safe to set the guest id.
         */
        if (!getBuyerId(document.cookie)) {
            setGuestId();
        }

        this.props.onUserRefetch(variables, null, err => {
            /**
             * Mimick relay behaviour - only change the variables after a successful refetch.
             */
            if (err) {
                this.userFetched = false;
            } else if (this.props.shouldUpdateRelayVariables) {
                this.props.updateRelayVariables(variables);
            }
        });

        this.userFetched = variables.fetchUser;
    }

    getUserRelayVars() {
        /**
         * Must default to an empty string! Because the default value for userId in the
         * relay query is set to an empty string. Defaulting to anything different will ruin
         * your day, trust me ;)
         */
        const userId = getBuyerId(document.cookie) || '';
        const userType = getUserType(document.cookie);
        return {
            userId,
            fetchUser: !!userId,
            userIds: userId ? [userId] : [],
            relationshipUserIds: userId ? [userId] : [],
            fetchFollowSearch: !!userId,
            isTrade: userType === CUSTOMER_TYPE_TRADE,
            fetchRegionalInfo: !userId,
        };
    }

    render() {
        return null;
    }
}

function mapStateToProps(state) {
    return {
        /**
         * updateUserState is used for responsive. The authentication is on the navigation is
         * managed in dbl, so we need to know when a user has successfully logged in/registered
         *
         * fetchUser is used for mobile. The mobile nav works a little bit differently from dbl.
         * It calls a callback when a user clicks an auth button and we handle all of the auth
         * flow in `app-buyer-finding`.
         *
         * TODO: Make sure they work the same way.
         * NOTE: updateUserState does not seem to exist, even for responsive it is using fetchUser
         */
        fetchUser: state.header.updateUserState || state.relayVariables.variables.fetchUser,
    };
}

SharedUserAndRelayVarLoaderComponent.defaultProps = {
    shouldUpdateRelayVariables: true,
};

SharedUserAndRelayVarLoaderComponent.propTypes = {
    updateRelayVariables: PropTypes.func.isRequired,
    onUserRefetch: PropTypes.func.isRequired,
    fetchUser: PropTypes.bool.isRequired,
    shouldUpdateRelayVariables: PropTypes.bool.isRequired,
};

export const SharedUserAndRelayVarLoader = connect(
    mapStateToProps,
    { updateRelayVariables }
)(SharedUserAndRelayVarLoaderComponent);
